import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { RefreshCw } from 'lucide-react';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, checkAuth, user } = useAuth();
  const location = useLocation();
  const [checking, setChecking] = useState(!location.state?.user);

  useEffect(() => {
    // If user data was passed from AuthCallback, skip auth check
    if (location.state?.user) {
      setChecking(false);
      return;
    }

    // Otherwise verify server-side
    const verify = async () => {
      await checkAuth();
      setChecking(false);
    };

    if (!user) {
      verify();
    } else {
      setChecking(false);
    }
  }, [location.state, checkAuth, user]);

  // Show loading while checking auth
  if (isLoading || checking) {
    return (
      <div className="min-h-screen bg-[#0a0a0f] flex items-center justify-center">
        <div className="text-center">
          <RefreshCw className="w-8 h-8 text-[#D4AF37] animate-spin mx-auto mb-4" />
          <p className="text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
